export default "__VITE_ASSET__CocIoWYM__"